var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_1446_21580)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 46,
    r: 40,
    fill: "url(#paint0_linear_1446_21580)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 46,
    r: 39.5,
    stroke: "white",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5 67.5C38.6259 67.5 29 57.8742 29 46C29 34.1259 38.6259 24.5 50.5 24.5C62.3742 24.5 72 34.1259 72 46C72 57.8742 62.3742 67.5 50.5 67.5ZM59.46 40.7551C60.429 40.2251 60.785 39.0099 60.255 38.0408C59.725 37.0716 58.5098 36.7156 57.5408 37.2456C53.8834 39.2457 50.8592 43.1058 48.8258 46.2192C48.0744 47.37 47.4324 48.4594 46.9188 49.3822C46.4397 48.9174 45.9652 48.514 45.5408 48.1784C44.9854 47.7394 44.4856 47.393 44.1213 47.1544L43.4912 46.763C42.5317 46.2158 41.3103 46.55 40.763 47.5096C40.2159 48.4688 40.5499 49.6898 41.5088 50.2374L41.9294 50.5004C42.215 50.6874 42.6153 50.9646 43.0599 51.3162C43.9751 52.0396 44.9625 52.988 45.584 54.027C45.9653 54.6646 46.6688 55.0382 47.4106 54.9974C48.1522 54.9564 48.8102 54.5072 49.1192 53.8318L49.3158 53.421C49.4512 53.1442 49.654 52.7394 49.918 52.2408C50.447 51.2414 51.2162 49.8744 52.1748 48.4064C54.1416 45.395 56.7172 42.255 59.46 40.7551Z",
    fill: "#0C0C83"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_1446_21580",
    x: -93.5,
    y: -98,
    width: 288,
    height: 288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 52
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1446_21580"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.956863 0 0 0 0 0.890196 0 0 0 0 0.898039 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1446_21580",
    result: "effect2_dropShadow_1446_21580"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1446_21580",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1446_21580",
    x1: 50.5,
    y1: 6,
    x2: 50.5,
    y2: 86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.31
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.9c706a8e9cd97292a22816ae682ec14d.svg";
export { ForwardRef as ReactComponent };